export const InlineResultMetricKeys: any = {
	result: 'metric:result',
	response: 'metric:response',
	resultHistograms: 'metric:result:histogramBuckets',
	responseHistograms: 'metric:response:histogramBuckets',
};
